/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CustomerApi } from '../api/customer.api';
import { switchMap, map } from 'rxjs/operators';
import { CustomerData, Customer } from '../../../interfaces/masters/customer';

@Injectable()
export class CustomerService extends CustomerData {

  constructor(private api: CustomerApi) {
    super();
  }



  list(url: string): Observable<Customer[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Customer>{
      return this.api.getById(url);
  }

  create(url: string, data:Customer): Observable<Customer> {
    return this.api.add(url,data);
  }

  update(url: string, data:Customer): Observable<Customer> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
